import React from 'react';
import styled from 'styled-components';
import { faLock } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import TrueImpactAlertIcon from 'shared/design-system/components/TrueImpactAlertIcon';

const StyledDiv = styled.div`
  min-height: 40vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${SPACERS.tiny};
  text-align: center;
  padding: ${SPACERS.large};
  h2 {
    margin: 0;
  }
  p {
    margin: ${SPACERS.extraTiny} 0 0;
  }
`;

interface AppUnauthenticatedProps {
  title?: string;
  message?: string;
}

const AppUnauthenticated: React.FC<AppUnauthenticatedProps> = ({
  title = 'You are not authorized',
  message = 'Please sign in to continue.',
}) => {
  return (
    <StyledDiv>
      <TrueImpactAlertIcon icon={faLock} />
      <h2>{title}</h2>
      <p>{message}</p>
    </StyledDiv>
  );
};

export default AppUnauthenticated;
